module.exports = __webpack_public_path__ + "static/img/icon_login.85a00868.svg";